import { CircularProgress } from '@mui/material';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';
import { useAccountDrawer } from 'context/accountDrawer';
import useGetAccount from 'hooks/services/account/useGetAccount';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PATH from 'crono-fe-common/constants/path';
import useGetProspectMutate from 'hooks/services/prospect/useGetProspectMutate';
import { useCustomLocation } from 'context/customLocation';

const ContactInterceptor = () => {
  const [searchParams] = useSearchParams();
  const accountId = searchParams.get('accountId') ?? undefined;
  const prospectId = searchParams.get('prospectId') ?? undefined;
  const openScoreParam = searchParams.get('openScore');
  const shouldOpenScore = openScoreParam === 'true' || openScoreParam === '1';

  const { openContactDrawer } = useAccountDrawer();

  const { setCustomStateLocation } = useCustomLocation();

  useGetAccount(accountId, undefined, undefined, undefined, undefined, {
    onSuccess: async (data) => {
      navigate(PATH.LISTS);
      setCustomStateLocation({
        listsPageTabState: 'Contact',
      });

      const accountObjectId = data?.data?.data.objectId;

      if (!accountObjectId || !prospectId) {
        console.error(
          `Tried opening contact but found accountObjectid: ${accountObjectId} and prospectId: ${prospectId}`,
        );
        return;
      }

      //I search if the contact is in the account
      const contact = await getProspectMutate({
        prospectId,
        withExternalProperties: false,
        withSequenceInstance: false,
        withAccount: false,
      });

      if (contact.data?.data) {
        openContactDrawer({
          accountId: accountObjectId,
          prospectId,
          openScore: shouldOpenScore,
        });
      }
    },
    onError: (error) => {
      console.error('Tried opening contact but failed to fetch account', error);
    },
  });

  const { mutateAsync: getProspectMutate } = useGetProspectMutate();

  const navigate = useNavigate();

  return (
    <FlexDiv>
      <CircularProgress />
    </FlexDiv>
  );
};

export default ContactInterceptor;
